/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable prefer-destructuring */
import React, { createContext, useContext, useMemo, useState } from 'react'
import { postRenovacaoPlanoAPI } from '../api/renovacao.servico'
import { useGlobal } from './GlobalContext'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import {
  METODO_PAGAMENTO_CARTAO,
  METODO_PAGAMENTO_PIX,
  PLANO_ANUAL,
  ROUTE_BASEPATH
} from '../constants'
import { ETAPA_BRINDES, ETAPA_CONCLUSAO, ETAPA_ENTREGA, ETAPA_PAGAMENTO } from '../components/FluxosPagamento/constantsFluxosPagamento'
import {
  BASES_OBRIGATORIAS_RENOVACAO,
  BASES_OPCIONAIS_RENOVACAO,
  BASE_PROPRIEDADE_ASSINATURA_RENOVACAO,
  BASE_PROPRIEDADE_BRINDE_RENOVACAO,
  BASE_PROPRIEDADE_CUPONS_RENOVACAO,
  BASE_PROPRIEDADE_ENTREGA_RENOVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_RENOVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_CARTAO_RENOVACAO
} from '../containers/Modalidade/Plano/RenovacaoPlano/constantsRenovacaoPlano'
import {
  cadastraEnderecoVigente
} from '../api/endereco.servico'
import ErrorMessages from '../utils/adyen/ErrorMessages'
import { navigate } from '@reach/router'
import { URLS_APP } from '../config'
import { renovationEvent, userDataEvent } from '../utils/events/events'
import { rdRenovationEvent } from '../utils/events/eventsRdStation'
import { getDadosAssociado } from '../api/associado.servico'

const RenovacaoPlanoContext = createContext()

function RenovacaoPlanoProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosRetornoRequisicao': null,
    'loadingRequisicaoRenovacao': false,
    'renovarCombo': false,
    'sucessoRenovacao': false,
    'tipoPagamentoRenovacao': null
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <RenovacaoPlanoContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useRenovacaoPlano() {
  const context = useContext( RenovacaoPlanoContext )
  if ( !context ) {
    throw new Error( 'useRenovacaoPlano deve ser usado dentro de um RenovacaoPlanoProvider' )
  }

  const { state, setState } = context
  const { setErroRequisicao, modalidadeURL } = useGlobal()

  const setSucessoRenovacao = sucesso => {
    setState( prevState => ( {
      ...prevState,
      'sucessoRenovacao': sucesso
    } ) )
  }

  const setRenovarCombo = combo => {
    setState( prevState => ( {
      ...prevState,
      'renovarCombo': combo
    } ) )
  }

  const setTipoPagamentoRenovacao = pagamento => {
    setState( prevState => ( {
      ...prevState,
      'tipoPagamentoRenovacao': pagamento
    } ) )
  }

  const setLoadingRequisicaoRenovacao = loading => {
    setState( prevState => ( {
      ...prevState,
      'loadingRequisicaoRenovacao': loading
    } ) )
  }

  const setDadosRetornoRequisicao = dados => {
    setState( prevState => ( {
      ...prevState,
      'dadosRetornoRequisicao': dados
    } ) )
  }

  const verifyIfHasNewAdresAndMakeVigente = ( dadosRenovacao, objetoFinal ) => {
    if ( dadosRenovacao[ ETAPA_ENTREGA ].newEndereco ) {
      const novoEndereco = {
        'assinatura_id': `${objetoFinal.assinatura_id}`,
        'endereco': {
          'id': objetoFinal.entrega.id
        }
      }
      cadastraEnderecoVigente( novoEndereco )
    }
  }

  const postRenovacaoPlano = async(
    assinatura,
    dadosRenovacao,
    setEtapaAtiva = null
  ) => {
    let objetoFinal
    let isPagamentoCartao
    let isPagamentoPix
    setLoadingRequisicaoRenovacao( true )
    Object.entries( dadosRenovacao ).forEach( renovacao => {
      const [ chave, objeto ] = renovacao
      if ( !isEmptyObject( objeto ) ) {
        if ( chave === ETAPA_BRINDES ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_BRINDE_RENOVACAO ]: objeto.id
          }
        }

        if ( chave === ETAPA_ENTREGA ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ENTREGA_RENOVACAO ]: {
              'id': dadosRenovacao[ chave ].id
                ? Number( dadosRenovacao[ chave ].id )
                : null
            }
          }
        }

        if ( chave === ETAPA_PAGAMENTO ) {
          const hasParcelaCartaoCredito = objetoTemPropriedade(
            dadosRenovacao[ chave ],
            'parcela'
          )
            ? dadosRenovacao[ chave ].parcela
            : 0
          const hasPromocao =
            objetoTemPropriedade( dadosRenovacao[ chave ], 'promocao' ) &&
            !isEmptyObject( dadosRenovacao[ chave ].promocao )
              ? dadosRenovacao[ chave ].promocao.codigo
              : null

          if ( dadosRenovacao[ chave ].metodoPagamento === METODO_PAGAMENTO_CARTAO.slug ) {
            isPagamentoCartao = true
            isPagamentoPix = false
          } else if ( dadosRenovacao[ chave ].metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
            isPagamentoCartao = false
            isPagamentoPix = true
          }

          if ( hasPromocao ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CUPONS_RENOVACAO ]: [ hasPromocao ]
            }
          }

          const getIdBackendMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return Number( dadosRenovacao[ chave ].id )
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.idBackend
            }
          }

          const getTipoMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return METODO_PAGAMENTO_CARTAO.slugBackend
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.slugBackend
            }
          }

          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PAGAMENTO_RENOVACAO ]: {
              [ BASE_PROPRIEDADE_PAGAMENTO_CARTAO_RENOVACAO ]: {
                'cvv': isPagamentoCartao
                  ? dadosRenovacao[ ETAPA_CONCLUSAO ].confirmacaoCVV
                  : '',
                'id': getIdBackendMetodoPagamento()
              },
              'parcelas': isPagamentoCartao
                ? hasParcelaCartaoCredito
                : PLANO_ANUAL.parcelas,
              'tipo': getTipoMetodoPagamento()
            }
          }
        }

        if ( !isEmptyObject( assinatura ) ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ASSINATURA_RENOVACAO ]: assinatura.id
          }
        }
      }
    } )

    const podeFazerRenovacao = Object.keys( objetoFinal ).every( chave => BASES_OBRIGATORIAS_RENOVACAO.includes( chave ) ||
        BASES_OPCIONAIS_RENOVACAO.includes( chave ) )

    if ( podeFazerRenovacao ) {
      try {
        const { 'data': dados } = await postRenovacaoPlanoAPI( objetoFinal )
        if ( !isEmptyObject( dados.assinatura ) ) {
          verifyIfHasNewAdresAndMakeVigente( dadosRenovacao, objetoFinal )
          setSucessoRenovacao( true )
          setDadosRetornoRequisicao( dados.assinatura )
          setLoadingRequisicaoRenovacao( false )
          const dadosAssociado = ( await getDadosAssociado() ).data
          userDataEvent( {
            'email': dadosAssociado.email,
            'phone': dadosAssociado.telefone,
            'name': `${dadosAssociado.nome} ${dadosAssociado.sobrenome}`,
            'userId': dadosAssociado.id,
            'productPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.kit,
            'freightPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.frete,
            'totalDiscount': dados.assinatura.vendas[ 0 ].pagamento.desconto.total,
            'paymentHash': dados.assinatura.vendas[ 0 ].pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_RENOVACAO ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_RENOVACAO ][ 0 ] : null,
            'planId': dados.venda.plano.id,
          } )
          renovationEvent( {
            'paymentMethod': objetoFinal.pagamento.tipo,
            'productPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.kit,
            'freightPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.frete,
            'totalDiscount': dados.assinatura.vendas[ 0 ].pagamento.desconto.total,
            'paymentHash': dados.assinatura.vendas[ 0 ].pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_RENOVACAO ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_RENOVACAO ][ 0 ] : null,
            'planId': dados.venda.plano.id,
          } )
          rdRenovationEvent( {
            'planId': dados.venda.plano.id,
            'email': dadosAssociado.email,
          } )
        }
      } catch ( erros ) {
        setSucessoRenovacao( false )
        setLoadingRequisicaoRenovacao( false )

        if ( erros && ( erros.request || erros.response ) ) {
          const { message } =
            erros?.response?.data?.errors[ 0 ] || 'Contate o suporte'
          if ( ErrorMessages.includes( message ) ) {
            const descricaoErro = {
              'descricao': message,
              'titulo': 'Houve um erro no pagamento!'
            }
            setErroRequisicao( 400, descricaoErro )
            if ( message !== 'CVV inválido.' && setEtapaAtiva ) {
              setEtapaAtiva( 2 )
              navigate( `${ROUTE_BASEPATH}${
                URLS_APP.BASE_PATH ? '/' : ''
              }${modalidadeURL}/plano/renovar-plano/selecionar-pagamento` )
            }
          } else {
            const descricaoErro = {
              'descricao': message,
              'titulo': 'Erro inesperado!'
            }
            setErroRequisicao( 400, descricaoErro )
          }
        }
      }
    }
  }

  return {
    'dadosRetornoRequisicao': state.dadosRetornoRequisicao,
    'loadingRequisicaoRenovacao': state.loadingRequisicaoRenovacao,
    postRenovacaoPlano,
    'renovarCombo': state.renovarCombo,
    setRenovarCombo,
    setTipoPagamentoRenovacao,
    'sucessoRenovacao': state.sucessoRenovacao,
    'tipoPagamentoRenovacao': state.tipoPagamentoRenovacao,
    setLoadingRequisicaoRenovacao
  }
}

export { RenovacaoPlanoProvider, useRenovacaoPlano }
